
import request from '@/axios'

export function priorityList () {
  return request({
    url: '/ClientUser/tasks/priority1/list',
    method: 'GET'
  })
}
export function taskList (queryParams) {
  return request({
    url: `/ClientUser/tasks/list?page=${queryParams.page}&limit=${queryParams.limit}&customer_id=${queryParams.customer_id}`,
    method: 'GET'
  })
}
export function taskCreate (customer_id, query) {
  return request({
    url: `tasks/create/${customer_id}`,
    method: 'POST',
    data: query
  })
}
export function taskUpdate (task_id, query) {
  return request({
    url: `/ClientUser/tasks/update/${task_id}`,
    method: 'POST',
    data: query
  })
}
export function taskDelete (customer_id, query) {
  return request({
    url: `tasks/delete/${customer_id}`,
    method: 'POST',
    data: query
  })
}
export function taskTemplateDelete (customer_id, query) {
  return request({
    url: `tasks/delete/templates/${customer_id}`,
    method: 'POST',
    data: query
  })
}
export function taskTemplateUpdate (customer_id, task_id, query) {
  return request({
    url: `tasks/update/template/${customer_id}/${task_id}`,
    method: 'POST',
    data: query
  })
}
export function taskShow (task_id) {
  return request({
    url: `/ClientUser/tasks/show/${task_id}`,
    method: 'GET'
  })
}

export function taskTemplateShow (customer_id, task_id) {
  return request({
    url: `tasks/show/templates/${customer_id}/${task_id}`,
    method: 'GET'
  })
}

export function fetchUserClient (user_type, customer_id, query) {
  return request({
    url: `/users/fetch_user_list/${user_type}/${customer_id}?page=${query.page}`,
    method: 'GET'
  })
}

export function unassociatedList (customer_id, queryParams = 1) {
  return request({
    url: `tasks/unassociated/list/${customer_id}?page=${queryParams}`,
    method: 'GET'
  })
}


export function projectCreate (customer_id, query) {
  return request({
    url: `projects/create/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function projectList (queryParams) {
  return request({
    url: `/ClientUser/projects/list?page=${queryParams.current_page}&limit=${queryParams.limit}&customer_id=${queryParams.customer_id}`,
    method: 'GET'
  })
}

export function projectShow (project_id) {
  return request({
    url: `/ClientUser/projects/show/${project_id}`,
    method: 'GET'
  })
}


export function projectUpdate (customer_id, project_id, query) {
  return request({
    url: `projects/update/${customer_id}/${project_id}`,
    method: 'POST',
    data: query
  })
}

export function projectDelete (customer_id, project_id, query) {
  return request({
    url: `projects/delete/${customer_id}/${project_id}`,
    method: 'POST',
    data: query
  })
}

export function projectKanbanShow (project_id) {
  return request({
    url: `/ClientUser/projects/kanban/${project_id}`,
    method: 'GET'
  })
}

export function taskStatusCheck (customer_id, project_id) {
  return request({
    url: `projects/check/status/${customer_id}/${project_id}`,
    method: 'GET'
  })
}
export function parentTask (customer_id, queryParams = 1) {
  return request({
    url: `tasks/parent/list/${customer_id}?page=${queryParams}`,
    method: 'GET'
  })
}

export function tagList (customer_id, queryParams = 1, query) {
  return request({
    url: `/tag/all/${customer_id}?page=${queryParams}`,
    method: 'POST',
    data: query
  })
}

export function createLog (task_id, query) {
  return request({
    url: `/ClientUser/tasks/logs/create/${task_id}`,
    method: 'POST',
    data: query
  })
}
